(function () {
  function normalize(text) {
    return String(text || "")
      .toLowerCase()
      .replace(/ä/g, "ae")
      .replace(/ö/g, "oe")
      .replace(/ü/g, "ue")
      .replace(/ß/g, "ss")
      .replace(/×/g, "x")
      .replace(/–|—/g, "-")
      .replace(/&|\+|\//g, " ")
      .replace(/[^a-z0-9\s-]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function compact(text) {
    return normalize(text).replace(/[\s-]/g, "");
  }

  function terms(value) {
  if (Array.isArray(value)) {
    value = value.join(",");
  }

  if (value && typeof value === "object") {
    value = Object.values(value).join(",");
  }

  return normalize(value)
    .split(/[\s,;|]+/)
    .map(function (v) { return v.trim(); })
    .filter(function (v) { return v.length > 1; });
}

  function unique(arr) {
    var seen = {};
    return arr.filter(function (item) {
      var key = item.url || item.title;
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function buildProductTerms(profile) {
    var set = {};
    [
      profile.tags,
      profile.usecase,
      profile.einsatz,
      profile.holz,
      profile.bretttyp,
      profile.beste_wahl,
      profile.format
    ].forEach(function (value) {
      terms(value).forEach(function (t) {
        set[t] = true;
      });
    });
    return Object.keys(set);
  }

  function categoryLabel(cat, guide) {
    var c = normalize((cat || "") + " " + ((guide && guide.tags) || "") + " " + ((guide && guide.title) || ""));

    if (c.indexOf("groesse") > -1 || c.indexOf("35x25") > -1 || c.indexOf("40x30") > -1 || c.indexOf("50x40") > -1 || c.indexOf("60x40") > -1 || c.indexOf("70x40") > -1 || c.indexOf("80x40") > -1) return "Größenvergleich";
    if (c.indexOf("vergleich") > -1 || c.indexOf("oder") > -1 || c.indexOf("entscheidung") > -1 || c.indexOf("kaufhilfe") > -1) return "Kaufhilfe";
    if (c.indexOf("bbq") > -1 || c.indexOf("grill") > -1 || c.indexOf("steak") > -1 || c.indexOf("burger") > -1 || c.indexOf("fleisch") > -1) return "BBQ & Fleisch";
    if (c.indexOf("servieren") > -1 || c.indexOf("gaeste") > -1 || c.indexOf("anrichten") > -1 || c.indexOf("tellerersatz") > -1) return "Servieren";
    if (c.indexOf("pflege") > -1 || c.indexOf("oel") > -1 || c.indexOf("patina") > -1) return "Pflege";
    if (c.indexOf("holz") > -1 || c.indexOf("eiche") > -1 || c.indexOf("nussbaum") > -1) return "Holzart";

    return "Kaufhilfe";
  }

  var areaLabels = {
    alle: "Passende Ratgeber",
    vergleich: "Zur Kaufentscheidung",
    groessen: "Zur Größe & Arbeitsfläche",
    bbq: "Zu BBQ, Steak & Servieren",
    holz: "Zur Holzart",
    pflege: "Zur Pflege & Nutzung"
  };

  function areaKey(guide) {
    var c = normalize([guide.category, guide.tags, guide.title, guide.search].join(" "));

    if (c.indexOf("vergleich") > -1 || c.indexOf("oder") > -1 || c.indexOf("entscheidung") > -1 || c.indexOf("kaufhilfe") > -1) return "vergleich";
    if (c.indexOf("groesse") > -1 || c.indexOf("35x25") > -1 || c.indexOf("40x30") > -1 || c.indexOf("50x40") > -1 || c.indexOf("60x40") > -1 || c.indexOf("70x40") > -1 || c.indexOf("80x40") > -1) return "groessen";
    if (c.indexOf("bbq") > -1 || c.indexOf("grill") > -1 || c.indexOf("steak") > -1 || c.indexOf("burger") > -1 || c.indexOf("fleisch") > -1 || c.indexOf("servieren") > -1 || c.indexOf("anrichten") > -1 || c.indexOf("tellerersatz") > -1) return "bbq";
    if (c.indexOf("pflege") > -1 || c.indexOf("reinigen") > -1 || c.indexOf("oel") > -1 || c.indexOf("patina") > -1 || c.indexOf("schnittspuren") > -1) return "pflege";
    if (c.indexOf("holz") > -1 || c.indexOf("eiche") > -1 || c.indexOf("nussbaum") > -1 || c.indexOf("ahorn") > -1 || c.indexOf("ulme") > -1) return "holz";

    return "alle";
  }

  function scoreGuide(guide, productTerms, profile) {
  var guideText = normalize([
    guide.title,
    guide.description,
    guide.category,
    guide.tags,
    guide.search,
    guide.url
  ].join(" "));

  var guideCompact = compact(guideText);
  var score = 0;
  var matched = {};

  var weakTerms = {
    schneidebrett:true,
    massivholz:true,
    brett:true,
    holz:true,
    ratgeber:true,
    kaufhilfe:true
  };

  productTerms.forEach(function(term){
    if(!term || weakTerms[term] || matched[term]) return;

    var ct = compact(term);

    if(guideText.indexOf(term) > -1){
      score += 80;
      matched[term] = true;
      return;
    }

    if(ct.length >= 4 && guideCompact.indexOf(ct) > -1){
      score += 70;
      matched[term] = true;
      return;
    }
  });

  var format = normalize(profile.format);
  var holz = normalize(profile.holz);
  var bretttyp = normalize(profile.bretttyp);

  if(format && guideText.indexOf(format) > -1) score += 90;
  if(format && guideCompact.indexOf(compact(format)) > -1) score += 80;

  if(holz && guideText.indexOf(holz) > -1) score += 35;
  if(bretttyp && guideText.indexOf(bretttyp) > -1) score += 60;

  guide._matched = Object.keys(matched);
  guide._area = areaKey(guide);

  return score;
}
  function cardHTML(guide) {
    var label = categoryLabel(guide.category, guide);
    var safeTitle = String(guide.title || "").replace(/"/g, "&quot;");
    var desc = guide.description || "";
    var img = guide.image
      ? '<div class="wm-rg-img"><img src="' + guide.image + '" alt="' + safeTitle + '" loading="lazy"></div>'
      : "";

    return '' +
      '<a class="wm-rg-card" href="' + guide.url + '">' +
        img +
        '<div class="wm-rg-body">' +
          '<div class="wm-rg-cat">' + label + '</div>' +
          '<strong>' + guide.title + '</strong>' +
          '<span>' + desc + '</span>' +
          '<div class="wm-rg-meta">ca. 5 Min. lesen</div>' +
          '<div class="wm-rg-cta">Ratgeber lesen →</div>' +
        '</div>' +
      '</a>';
  }

  function rowHTML(guide, hidden) {
    var safeTitle = String(guide.title || "").replace(/"/g, "&quot;");
    var img = guide.image
      ? '<div class="wm-rg-row-img"><img src="' + guide.image + '" alt="' + safeTitle + '" loading="lazy"></div>'
      : '<div class="wm-rg-row-img"></div>';

    return '' +
      '<a class="wm-rg-row' + (hidden ? ' is-hidden' : '') + '" href="' + guide.url + '">' +
        img +
        '<div>' +
          '<strong>' + guide.title + '</strong>' +
          '<small>Ratgeber lesen →</small>' +
        '</div>' +
      '</a>';
  }

  function render(root, ranked) {
    var target = root.querySelector("[data-wm-results]");
    var questions = root.querySelector("[data-wm-questions]");
    var nav = root.querySelector("[data-wm-area-nav]");
    var areas = root.querySelector("[data-wm-areas]");

    if (!target) return;

    if (!ranked.length) {
      target.innerHTML = '<p class="wm-rg-note">Keine passenden Ratgeber gefunden.</p>';
      return;
    }

    target.innerHTML = ranked.slice(0, 4).map(cardHTML).join("");

    if (!questions || !nav || !areas) return;

    var fixedKeys = ["alle", "vergleich", "groessen", "bbq", "holz", "pflege"];

    questions.hidden = false;
    nav.innerHTML = "";
    areas.innerHTML = "";

    fixedKeys.forEach(function (key, index) {
      var list;

      if (key === "alle") {
        list = ranked.slice(4, 12);
      } else {
        list = ranked.filter(function (g) {
          return g._area === key;
        }).slice(0, 8);
      }

      var btn = document.createElement("button");
      btn.type = "button";
      btn.textContent = areaLabels[key];
      btn.dataset.area = key;
      if (index === 0) btn.classList.add("is-active");
      nav.appendChild(btn);

      var block = document.createElement("div");
      block.className = "wm-rg-area" + (index === 0 ? "" : " is-hidden");
      block.dataset.area = key;

      block.innerHTML =
        '<h4>' + areaLabels[key] + '</h4>' +
        '<div class="wm-rg-list">' +
          (list.length
            ? list.map(function (g, i) { return rowHTML(g, i > 2); }).join("")
            : '<p class="wm-rg-note">Für diese Rubrik gibt es aktuell keinen enger passenden Treffer.</p>'
          ) +
        '</div>';

      if (list.length > 3) {
        var more = document.createElement("div");
        more.className = "wm-rg-area-more";
        more.innerHTML = '<button type="button">Mehr Fragen anzeigen</button>';
        block.appendChild(more);
      }

      areas.appendChild(block);
    });

    nav.addEventListener("click", function (e) {
      if (!e.target.matches("button")) return;

      var key = e.target.dataset.area;

      nav.querySelectorAll("button").forEach(function (b) {
        b.classList.toggle("is-active", b.dataset.area === key);
      });

      areas.querySelectorAll(".wm-rg-area").forEach(function (a) {
        a.classList.toggle("is-hidden", a.dataset.area !== key);
      });
    });

    areas.addEventListener("click", function (e) {
      if (!e.target.matches(".wm-rg-area-more button")) return;

      var area = e.target.closest(".wm-rg-area");
      area.querySelectorAll(".wm-rg-row.is-hidden").forEach(function (row) {
        row.classList.remove("is-hidden");
      });

      e.target.closest(".wm-rg-area-more").remove();
    });
  }

  document.querySelectorAll(".wm-related-guides").forEach(function (root) {
    var profileEl = root.querySelector(".wm-product-profile-json");
    var guideEl = root.querySelector(".wm-guide-index-json");

    if (!profileEl || !guideEl) return;

    var profile, guides;

    try {
      profile = JSON.parse(profileEl.textContent);
      guides = JSON.parse(guideEl.textContent);
    } catch (e) {
      var target = root.querySelector("[data-wm-results]");
      if (target) target.innerHTML = '<p class="wm-rg-note">Ratgeber-Daten konnten nicht gelesen werden.</p>';
      return;
    }

    var productTerms = buildProductTerms(profile);

    var ranked = unique(guides)
      .map(function (guide) {
        guide.score = scoreGuide(guide, productTerms, profile);
        return guide;
      })
      .filter(function (guide) {
        return guide.url && guide.title && guide.score > 0;
      })
      .sort(function (a, b) {
        return b.score - a.score;
      });

    render(root, ranked);
  });
})();